/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useEffect, useRef } from "react";
import mermaid from "mermaid";

mermaid.initialize({
  startOnLoad: false,
  theme: "base",
  themeVariables: {
    primaryColor: "#e8f0ff",
    primaryBorderColor: "#4285fb",
    primaryTextColor: "#1e293b",
    secondaryColor: "#e8f0ff",
    secondaryBorderColor: "#4285fb",
    tertiaryColor: "#f0f5ff",
    tertiaryBorderColor: "#93b4fb",
    noteBkgColor: "#e8f0ff",
    noteBorderColor: "#4285fb",
    noteTextColor: "#1e40af",
    actorBkg: "#e8f0ff",
    actorBorder: "#4285fb",
    actorTextColor: "#1e293b",
    signalColor: "#4285fb",
    signalTextColor: "#1e293b",
    sequenceNumberColor: "#fff",
    labelBoxBkgColor: "#e8f0ff",
    labelBoxBorderColor: "#4285fb",
    labelTextColor: "#1e293b",
    loopTextColor: "#1e293b",
    fontSize: "10px",
  },
  sequence: {
    diagramMarginX: 16,
    diagramMarginY: 10,
    actorMargin: 50,
    width: 200,
    height: 36,
    boxMargin: 6,
    boxTextMargin: 6,
    noteMargin: 8,
    messageMargin: 35,
    mirrorActors: false,
    useMaxWidth: false,
    wrap: true,
  },
});

const v1Diagrams = [
  {
    id: "kyc",
    requires: ["kyc"],
    title: "Verifying an Individual (KYC)",
    description: "Create an entity, run a verification workflow, receive results via webhook, then retrieve the full outcome.",
    def: `sequenceDiagram
    autonumber
    participant You as Your System
    participant API as FrankieOne V1 API
    participant WH as Your Webhook Endpoint
    participant Portal as FrankieOne Portal

    You->>API: POST /entity
    API-->>You: 200 { entityId }

    You->>API: POST /entity/{entityId}/verify/safe_harbour/full
    API-->>You: 200 { requestId }

    Note over API,WH: Workflow executes —<br/>data sources cascade

    API->>WH: Webhook: FUNCTION<br/>{ requestId, entityId }
    WH-->>You: Forward

    You->>API: GET /entity/{entityId}/checks
    API-->>You: 200 { actionRecommended, riskLevel }

    You--)Portal: Review entity + checks`,
  },
  {
    id: "idv",
    requires: ["idv"],
    title: "Document Verification (IDV via OneSDK)",
    description: "Generate a hosted capture URL, user completes ID + selfie on their device, FrankieOne OCRs and runs the workflow automatically.",
    def: `sequenceDiagram
    autonumber
    participant You as Your System
    participant API as FrankieOne V1 API
    participant SDK as Hosted OneSDK
    participant User as User Device
    participant WH as Your Webhook Endpoint

    You->>API: POST /idv/v2/idvalidate/onboarding-url<br/>{ flowId, consent: true }
    API-->>You: 200 { url }

    You->>User: Send URL (SMS / email / redirect)
    User->>SDK: Open link

    Note over SDK,User: Capture ID front,<br/>back + selfie

    SDK->>API: Submit images

    Note over API,SDK: OCR → entity created →<br/>workflow runs automatically

    API->>WH: Webhook: FUNCTION<br/>{ entityId }
    WH-->>You: Forward

    You->>API: GET /entity/{entityId}/checks
    API-->>You: 200 { actionRecommended }`,
  },
  {
    id: "kyb",
    requires: ["kyb"],
    title: "Verifying a Business (KYB + UBO KYC)",
    description: "Query business ownership, collect missing UBO details, run KYC on each individual, and screen the organisation for AML.",
    def: `sequenceDiagram
    autonumber
    participant You as Your System
    participant API as FrankieOne V1 API
    participant WH as Your Webhook Endpoint
    participant Portal as FrankieOne Portal

    You->>API: POST /business/ownership/query { ACN }
    API-->>You: 202 { requestId, entityId }

    Note over API,WH: ASIC/ABR lookup +<br/>UBO resolution (async)

    API->>WH: Webhook: FUNCTION — ownership done
    WH-->>You: Forward

    You->>API: GET /entity/{entityId}/checks
    API-->>You: 200 { UBOs, directors }

    Note over You,API: Collect missing UBO<br/>details (DOB, address, docs)

    rect rgb(240, 245, 255)
    Note left of You: Repeat per UBO
    You->>API: POST /entity/{entityId} — update UBO
    API-->>You: 200 OK

    You->>API: POST /entity/{entityId}/verify/safe_harbour/full
    API-->>You: 200 { requestId }

    API->>WH: Webhook: UBO KYC complete
    end

    You->>API: POST /entity/{entityId}/verify/pep_media/full
    API->>WH: Webhook: org AML complete

    You--)Portal: Review all results`,
  },
];

const v2Diagrams = [
  {
    id: "kyc-v2",
    requires: ["kyc"],
    title: "Verifying an Individual (KYC)",
    description: "Create an individual, execute a KYC workflow, receive the workflowResult with status and risk assessment.",
    def: `sequenceDiagram
    autonumber
    participant You as Your System
    participant API as FrankieOne V2 API
    participant WH as Your Webhook Endpoint
    participant Portal as FrankieOne Portal

    You->>API: POST /v2/individuals
    API-->>You: 200 { entityId }

    You->>API: POST /v2/individuals/{entityId}<br/>/serviceprofiles/{svc}<br/>/workflows/AUS-Basic2V-TwoPlus/execute
    API-->>You: 200 { workflowResult }

    Note over API,WH: Workflow executes —<br/>checks cascade

    alt Async workflow
    API->>WH: Webhook: workflow complete<br/>{ entityId, status }
    WH-->>You: Forward
    end

    Note over You: Check workflowResult.status<br/>PASS / FAIL / REVIEW

    You--)Portal: Review entity + results`,
  },
  {
    id: "idv-v2",
    requires: ["idv"],
    title: "Document Verification (IDV via OneSDK)",
    description: "Generate a hosted capture URL, user completes ID + selfie, FrankieOne OCRs and runs the workflow automatically.",
    def: `sequenceDiagram
    autonumber
    participant You as Your System
    participant API as FrankieOne V2 API
    participant SDK as Hosted OneSDK
    participant User as User Device
    participant WH as Your Webhook Endpoint

    You->>API: POST /idv/v2/idvalidate<br/>/onboarding-url { consent: true }
    API-->>You: 200 { url }

    You->>User: Send URL (SMS / email / redirect)
    User->>SDK: Open link

    Note over SDK,User: Capture ID front,<br/>back + selfie

    SDK->>API: Submit images

    Note over API,SDK: OCR → entity created →<br/>workflow runs automatically

    API->>WH: Webhook: workflow complete<br/>{ entityId, status }
    WH-->>You: Forward

    You->>API: GET execution result
    API-->>You: 200 { workflowResult }`,
  },
  {
    id: "kyb-v2",
    requires: ["kyb"],
    title: "Verifying a Business (KYB + UBO KYC)",
    description: "Create an organization, execute KYB workflow, collect missing UBO details, run KYC on each individual.",
    def: `sequenceDiagram
    autonumber
    participant You as Your System
    participant API as FrankieOne V2 API
    participant WH as Your Webhook Endpoint
    participant Portal as FrankieOne Portal

    You->>API: POST /v2/organizations { ACN }
    API-->>You: 200 { entityId }

    You->>API: POST /v2/organizations/{entityId}<br/>/serviceprofiles/{svc}<br/>/workflows/AUS-Business-KYB/execute
    API-->>You: 202 { workflowExecutionId }

    Note over API,WH: ASIC/ABR lookup +<br/>UBO resolution (async)

    API->>WH: Webhook: KYB complete
    WH-->>You: Forward

    Note over You,API: Collect missing UBO<br/>details (DOB, address, docs)

    rect rgb(240, 245, 255)
    Note left of You: Repeat per UBO
    You->>API: POST /v2/individuals/{uboId}<br/>/serviceprofiles/{svc}<br/>/workflows/AUS-Basic2V-TwoPlus/execute
    API-->>You: 200 { workflowResult }
    end

    You--)Portal: Review all results`,
  },
];

function MermaidDiagram({ id, definition }: { id: string; definition: string }) {
  const ref = useRef(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { svg } = await mermaid.render(id, definition);
        if (cancelled || !ref.current) return;

        // Convert to a fixed-size PNG so browser cannot rescale the SVG
        // and all diagrams have identical text size
        const container = document.createElement("div");
        container.innerHTML = svg;
        const svgEl = container.querySelector("svg");
        if (!svgEl) { ref.current.innerHTML = svg; return; }

        // Read the natural pixel dimensions Mermaid calculated
        const w = parseFloat(svgEl.getAttribute("width")) || 800;
        const h = parseFloat(svgEl.getAttribute("height")) || 400;

        // Ensure SVG has explicit size + xmlns for Blob rendering
        svgEl.setAttribute("width", w);
        svgEl.setAttribute("height", h);
        svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        const svgData = new XMLSerializer().serializeToString(svgEl);
        const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(blob);

        const scale = 2; // 2x for crisp text
        const canvas = document.createElement("canvas");
        canvas.width = w * scale;
        canvas.height = h * scale;
        const ctx = canvas.getContext("2d");

        const img = new Image();
        img.onload = () => {
          if (cancelled) { URL.revokeObjectURL(url); return; }
          ctx.scale(scale, scale);
          ctx.drawImage(img, 0, 0, w, h);
          URL.revokeObjectURL(url);
          const png = canvas.toDataURL("image/png");
          if (ref.current) {
            // Display at NATURAL width (not 100%) — narrower diagrams stay narrow
            ref.current.innerHTML = `<img src="${png}" alt="Sequence diagram" style="width:${w}px;max-width:100%;height:auto;display:block;" />`;
          }
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          if (ref.current) ref.current.innerHTML = svg;
        };
        img.src = url;
      } catch (e) {
        if (!cancelled && ref.current) ref.current.innerHTML = `<pre style="color:red;font-size:11px">${e.message}</pre>`;
      }
    })();
    return () => { cancelled = true; };
  }, [id, definition]);

  return <div ref={ref} style={{ display: "flex", justifyContent: "center", overflow: "auto" }} />;
}

export default function SequenceDiagrams({ checks = {}, apiVersion = "v1" }: { checks?: Record<string, boolean>; apiVersion?: string }) {
  const allDiagrams = apiVersion === "v2" ? v2Diagrams : v1Diagrams;
  const visible = allDiagrams.filter(d =>
    d.requires.length === 0 || d.requires.some(r => checks[r])
  );

  return (
    <div>
      <h2 style={{ color: "#4285fb", borderBottom: "2px solid #4285fb", paddingBottom: 6, marginBottom: 16 }}>
        Sequence Diagrams
      </h2>
      <p style={{ fontSize: 12, color: "#444", lineHeight: 1.6, marginBottom: 20 }}>
        These diagrams show the API call sequences for common integration flows.
        Solid arrows are requests, dashed arrows are responses, and dotted lines are optional steps.
      </p>
      {visible.map((d) => (
        <div key={d.id} style={{ marginBottom: 36, pageBreakInside: "avoid" }}>
          <h3 style={{ color: "#333", marginBottom: 6 }}>{d.title}</h3>
          {d.description && <p style={{ fontSize: 11, color: "#666", lineHeight: 1.5, marginBottom: 12, marginTop: 0 }}>{d.description}</p>}
          <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: 8, padding: 16, overflowX: "auto" }}>
            <MermaidDiagram id={`seq-${d.id}`} definition={d.def} />
          </div>
        </div>
      ))}
    </div>
  );
}
